import { COMPANY_FILTER_CHANGE } from '../../PartnerOptions/constants'
import { ADD_LANDING_PAGE_ASYNC, EDIT_LANDING_PAGE_ASYNC } from '../LandingPageForm/constants'

import {
  COPY_LANDING_PAGE_ASYNC,
  DELETE_LANDING_PAGE_ASYNC,
  LANDING_PAGES_REQUEST_ASYNC,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SEARCH_RESET,
} from './constants'

export default function () {
  const initialState = {
    data: {
      items: [],
    },
    page: 1,
    languages: [],
    loader: false,
    error: null,
    search: '',
    message: null,
    partner: false,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case SEARCH_RESET:
        return {
          ...state,
          search: '',
          error: null,
          message: null,
        }
      case SEARCH_CHANGE:
        return {
          ...state,
          search: action.payload.q,
          loader: true,
          error: null,
          page: 1,
          message: null,
        }
      case PAGINATE_CHANGE:
        return {
          ...state,
          page: action.payload.page,
          loader: true,
          message: null,
          error: null,
        }
      case COMPANY_FILTER_CHANGE:
        return {
          ...state,
          page: 1,
          loader: true,
          message: null,
          error: null,
        }
      case LANDING_PAGES_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
        }
      case LANDING_PAGES_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          data: {
            ...action.payload.data,
            items: action.payload.data.items.reduce((acc, cur) => {
              acc[cur.id] = cur
              return acc
            }, {}),
          },
          loader: false,
        }
      case LANDING_PAGES_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          error: action.error,
          message: action.error,
        }
      case LANDING_PAGES_REQUEST_ASYNC.CANCEL:
        return {
          ...state,
          loader: false,
          page: 1,
        }
      case DELETE_LANDING_PAGE_ASYNC.INITIATE:
        return {
          ...state,
          message: null,
          loader: true,
        }
      case DELETE_LANDING_PAGE_ASYNC.SUCCESS:
        return {
          ...state,
          message: 'Landing Page deleted successfully!',
        }
      case DELETE_LANDING_PAGE_ASYNC.ERROR:
        return {
          ...state,
          error: action.error,
          message: action.error,
          loader: false,
        }
      case COPY_LANDING_PAGE_ASYNC.INITIATE:
        return {
          ...state,
          message: null,
          loader: false,
        }
      case COPY_LANDING_PAGE_ASYNC.SUCCESS:
        return {
          ...state,
          message: 'Landing Page copied successfully!',
        }
      case COPY_LANDING_PAGE_ASYNC.ERROR:
        return {
          ...state,
          error: action.error,
          message: action.error,
        }
      case COPY_LANDING_PAGE_ASYNC.CANCEL:
        return {
          ...state,
          loader: false,
          page: 1,
        }
      case ADD_LANDING_PAGE_ASYNC.INITIATE:
        return {
          ...state,
          message: null,
        }
      case ADD_LANDING_PAGE_ASYNC.SUCCESS:
        return {
          ...state,
          message: 'Landing Page created successfully!',
        }
      case ADD_LANDING_PAGE_ASYNC.CANCEL:
        return {
          ...state,
          message: null,
        }
      case EDIT_LANDING_PAGE_ASYNC.INITIATE:
        return {
          ...state,
          message: null,
        }
      case EDIT_LANDING_PAGE_ASYNC.SUCCESS:
        return {
          ...state,
          message: 'Landing Page saved successfully!',
        }
      case EDIT_LANDING_PAGE_ASYNC.CANCEL:
        return {
          ...state,
          message: null,
        }
      default:
        return state
    }
  }
}
